import styled from "styled-components";

export const MainWrapper = styled.div`
  padding-inline: 50px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  min-height: 0;
`;

